import React, {useCallback, useEffect, useState} from 'react';

import {MunshiMenu} from "../components/Menu";
import {InvoiceScroll} from "../components/Invoice/invoiceScroll";
import {CustomerSelect} from "../components/Select/CustomerSelect";

import dayjs from "dayjs";
import DrdTable from "../components/Invoice/DRD Table";

import InvoiceChecks from "../components/Invoice/InvoiceChecks";
import InvoiceTools from "../components/Invoice/InvoiceToolBar";
import {LocationSelect} from "../components/Select/LocationSelect";
import {Button} from 'primereact/button';
import {Serial} from "../components/Serial/serialEdit"
import Modal from 'react-bootstrap/Modal';
import {Sidebar} from "primereact/sidebar";
import {InvoiceBody} from "../components/Invoice/invoiceBody";
import {PrintInvoice} from "../print/InvoicePrint";
import {jDateToMySql, ToMySqlDate} from "../utilities/ToMySqlDate";
import Cookies from 'js-cookie'
import _ from "lodash";
import {ToastContainer} from 'react-toastify';
import {v4 as uuidv4} from "uuid";
import 'react-toastify/dist/ReactToastify.css';

import {axiosInstance} from "../utilities/AxiosConfig";
import {Scanner} from "../components/Image/ImageUtils";
import {useSpinner} from "../context/SpinnerContext";
import {notify} from "../components/toast";
import {sF, sI} from "../utilities/NumberFormatter";
import {Auths} from "../utilities/getAuthDep";
import {FloatLabel} from "primereact/floatlabel";
import {Calendar} from "primereact/calendar";


function Invoice({handle}) {
    const [invNumber, setInvNumber] = useState(0);
    const [contentList, setContentList] = useState([{
        id: uuidv4(),
        invoiceId: 0,
        itemId: 0,
        itemName: "",
        quantity: 0,
        price: 0.0,
        lastPrice: 0.0,
        stock: 0,
        total: 0,
        comment: ""
    }]);
    const [level] = useState(Auths)
    const [customer, setCustomer] = useState({id: 0, name: "", initialBalance: 0, customerGroup: 0});
    const [iDate, setIDate] = useState(new Date());
    const [refreshList, setRefreshList] = useState(false);
    const [location, setLocation] = useState({id: 0, name: "", customerId: 0});
    const [isPosted, setPosted] = useState(false);
    const [total, setTotal] = useState(0);
    const [vat, setVat] = useState(0);
    const [serialList, setSerialList] = useState([]);
    const [show, setShow] = useState(false);
    const [newLoaded, setNewLoaded] = useState(false);
    const [status, setStatus] = useState([
        {name: "Approval", status: false, user: "", date: ""}, {
            name: "Ready",
            status: false,
            user: "",
            date: ""
        }, {name: "Invoiced", status: false, user: "", date: ""}, {
            name: "Delivered",
            status: false,
            user: "",
            date: ""
        }])
    const [visible, setVisible] = useState(false);
    const [invoiceList, setInvoiceList] = useState([])
    const [dues, setDues] = useState(["Balance: None", "40: None", "60 None"])
    const [showPrint, setShowPrint] = useState(false)
    const [body, setBody] = useState([])
    const [header, setHeader] = useState({})
    const [showImage, setShowImage] = useState(false)
    const [transfer, setTransfer] = useState(false)
    const [isApproved, setApproved] = useState(false)
    const [isReady, setReady] = useState(false)
    const [isInvoiced, setInvoiced] = useState(false)
    const [isDelivered, setDelivered] = useState(false)
    const [isEnablePrice, setEnablePrice] = useState(false)
    const [user, setUser] = useState();
    const [companyName, setCompanyName] = useState();
    const [itemList, setItemList] = useState([])
    const [customerList, setCustomerList] = useState([])
    const [locationList, setLocationList] = useState([])


    const [database, setDatabase] = useState("");
    const {loading, setLoading} = useSpinner();


    useEffect(() => {
        const fetchInitialData = async () => {
            setLoading(true);
            try {
                // Fetch all data in parallel for better performance
                const [locRes, bioRes, itemRes, custRes] = await Promise.all([
                    axiosInstance.get('location'),
                    axiosInstance.get('biodata/'),
                    axiosInstance.get('item'),
                    axiosInstance.get('customer')
                ]);

                setLocationList(locRes.data);
                setVat(sF(bioRes.data.vat));
                setCompanyName(bioRes.data.name);
                setItemList(itemRes.data);
                setCustomerList(custRes.data);
            } catch (error) {
                notify(error.message, "error");
            }

        };

        fetchInitialData().then(setLoading(false));
    }, []);

    useEffect(() => {
        setLocation(locationList[0])
    }, [setLocation, locationList])

    const setAllStatus = useCallback((allStatus) => {
        if (!allStatus) return;
        setStatus(allStatus);
        setApproved(allStatus[0].status);
        setReady(allStatus[1].status);
        setInvoiced(allStatus[2].status);
        setDelivered(allStatus[3].status)
        setEnablePrice(allStatus[1].status && !allStatus[2].status && !isPosted)

    }, [setStatus, setDelivered, setEnablePrice, isPosted])
    //Get User and Level
    useEffect(() => {
        setUser(Cookies.get('user') || "Guest");
        setDatabase(Cookies.get('database'));

    }, [])
    //Get Dues//
    useEffect(() => {
        if (customer.id > 0 && !transfer) {
            setLoading(true)
            axiosInstance.get(`account/${customer.id}`,).then((response) => {
                setDues(response.data);
            }).catch((error) => {
                notify(error.message, "error")
            }).finally(
                () => {
                    setLoading(false)
                }
            )
        } else {
            setDues(["Balance: None", "40: None", "60 None"])
        }
    }, [setCustomer, customer]);
    //Get InvoiceList//
    useEffect(() => {
        setLoading(true);
        axiosInstance
            .get("invoice/",)
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    setInvoiceList(response.data.reverse());
                } else {
                    setInvoiceList([]);
                }
            })
            .catch((error) => {
                notify(error.message, "error");
            }).finally(
            () => {
                setLoading(false)
            }
        );
    }, [refreshList, setRefreshList]);
    //set CustomerCategory
    useEffect(() => {
        if (customer.id > 0) {
            setLoading(true)
            axiosInstance.get(`customer/category/${customer.id}`).then((category) => {
                if (category.data === "S") {
                    setTransfer(true)
                } else {
                    setTransfer(false)
                }
            }).catch((error) => {
                notify(error.message, "error");
            }).finally(
                () => {
                    setLoading(false)
                }
            )
        }
    }, [customer.id, invNumber, setCustomer, customer])
    // Define a save function that can take status as an argument
    const performSave = useCallback((currentStatus) => {
        if (customer && customer.id > 0 && !isPosted && contentList && contentList.length > 0 && contentList[0].itemId !== 0) {
            setLoading(true)
            const ttl = contentList.reduce((a, b) => a + sF(b.total), 0);
            const vt = ttl * sF(vat) / 100;

            axiosInstance.post("invoice", {
                header: {
                    id: invNumber,
                    customerId: customer.id,
                    customerName: customer.name,
                    date: jDateToMySql(iDate),
                    status: transfer ? [
                        {name: "Approval", date: iDate, user: "Factory", status: true},
                        {name: "Ready", date: iDate, user: "Factory", status: true},
                        {name: "Invoiced", date: iDate, user: "Factory", status: true},
                        {name: "Delivered", date: iDate, user: "Factory", status: true}
                    ] : currentStatus,
                    posted: false,
                    location: location,
                    total: ttl + vt,
                    vat: vt,
                    comment: ""
                },
                body: contentList.filter(it => it.itemName.name !== ""),
                serial: serialList
            }).then((response) => {
                if (response.data === 0) {
                    notify("Invoice could not be saved. Please try again.", "error")
                    //               setAllStatus(currentStatus);
                    if (transfer) {
                        setAllStatus([
                            {name: "Approval", date: iDate, user: "Factory", status: true},
                            {name: "Ready", date: iDate, user: "Factory", status: true},
                            {name: "Invoiced", date: iDate, user: "Factory", status: true},
                            {name: "Delivered", date: iDate, user: "Factory", status: true}
                        ])
                    }
                    setRefreshList(!refreshList);
                } else {
                    notify("Invoice Saved Successfully", "success")
                    setInvNumber(response.data);
                    setRefreshList(!refreshList);
                    setAllStatus(currentStatus);
                }
            }).catch((error) => {
                setLoading(false)
                notify(error.message, "error")
            }).finally(() => {
                setAct("")
            })
        } else {
            notify("Please fill all the fields.", "error");
        }
    }, [customer, isPosted, contentList, vat, invNumber, iDate, transfer, location, serialList, refreshList, setAllStatus]);

    // Update setAct to use performSave
    const setAct = useCallback((act) => {
        if (act !== "") {
            switch (act) {
                case "ADD":
                    renewInvoice()
                    break;
                case "SAVE":

                    performSave(status);
                    break;
                case "UNDO":
                    renewInvoice();
                    setAct("")
                    break;
                case "DELETE":
                    if (invNumber > 0 && (!isApproved || transfer)) {
                        setLoading(true)
                        const tf = transfer ? 1 : 0
                        axiosInstance.delete(`invoice/${invNumber}&${tf}`).then((response) => {
                            if (response.data === 0) {
                                notify("Invoice could not be deleted. Please try again.", "error")
                            } else {
                                notify("Invoice Deleted Successfully", "success")
                                setInvNumber(0);
                                renewInvoice();
                                setRefreshList(!refreshList);
                            }
                        }).catch((error) => {
                            notify(error.message, "success");
                        }).finally(
                            () => {
                                setLoading(false)
                                setAct("")
                            }
                        )
                    } else {
                        notify("Invoice is not approved. Please approve the invoice first.", "error")
                    }
                    break;
                case "POST":
                    if (!isPosted && invNumber > 0 && (isDelivered || transfer) && level.posting()) {
                        setLoading(true)
                        axiosInstance.get(`invoice/post/id/${invNumber}`,).then((response) => {
                            if (response.data === 0) {
                                notify("Invoice could not be posted. Please try again.", "error")
                                setPosted(false)
                            } else {
                                notify(`Invoice ${invNumber} Posted Successfully`, "success");
                                setRefreshList(!refreshList);
                                setPosted(true)
                            }
                        }).catch((error) => {
                            notify(error.message, "error");
                        }).finally(
                            () => {
                                setLoading(false)
                                setAct("")
                            }
                        )

                    } else if (isPosted && invNumber > 0) {
                        notify("Invoice is already posted. Please unpost the invoice first.", "error")
                    } else {
                        notify("Invoice is not delivered. Please deliver the invoice first.", "error")
                    }
                    break;
                case "UNPOST":
                    if (isPosted && level.posting()) {
                        setLoading(true)
                        axiosInstance.get(`invoice/unpost/id/${invNumber}`,).then((response) => {
                            if (response.data === 0) {
                                notify("Invoice could not be unposted. Please try again.", "error")
                                setPosted(true)
                            }
                            notify(`Invoice ${invNumber} UnPosted Successfully`, "success");
                            setPosted(false)
                            setRefreshList(!refreshList);
                        }).catch((error) => {
                            notify(error.message, "error");
                        }).finally(
                            () => {
                                setLoading(false)
                                setAct("")
                            }
                        )
                    } else {
                        notify("Invoice is not posted. Please post the invoice first.", "error")
                    }
                    break;
                case "PRINT":
                    if (invNumber > 0) {
                        const body = Array.isArray(contentList) && contentList.length > 0
                            ? contentList.map((item) => ({
                                name: item.itemName,
                                quantity: item.quantity || 0,
                                price: sF(item.price) || 0,
                                total: (sF(item.price) || 0) * (item.quantity || 0),
                            }))
                            : [];
                        const header = {
                            invoiceId: invNumber,
                            customerName: customer.name,
                            date: ToMySqlDate(dayjs(iDate)),
                        }
                        setBody(body)
                        setHeader(header)
                        setShowPrint(true)
                        setAct("")
                    }
                    break;
                default:
                    setAct("")
                    break;
            }
        }
    }, [customer, isPosted, invNumber, iDate, status, location, total, vat, contentList, serialList, refreshList, isApproved, isDelivered, transfer, setAllStatus, performSave])
    const renewInvoice = () => {
        setLocation(locationList[0])
        setDues(["Balance: None", "40: None", "60 None"])
        const dt = new Date();
        setIDate(dt);
        setPosted(false);
        setTransfer(false);
        setInvNumber(0)
        setNewLoaded(false)
        setAllStatus([
            {name: "Approval", status: false, user: "", date: ""}, {
                name: "Ready",
                status: false,
                user: "",
                date: ""
            }, {name: "Invoiced", status: false, user: "", date: ""}, {
                name: "Delivered",
                status: false,
                user: "",
                date: ""
            }])
        setTotal(0);
        setVat(0);
        setSerialList([]);
        setCustomer({id: 0, name: "", initialBalance: 0, customerGroup: 0})
        setContentList([
            {
                id: uuidv4(),
                invoiceId: 0,
                itemId: 0,
                itemName: "",
                quantity: 0,
                price: 0.0,
                lastPrice: 0.0,
                stock: 0,
                total: 0.0,
                comment: ""
            }]);
    }
    const getInvoice = (invNum) => {
        if (invNum <= 0) return;
        const controller = new AbortController();
        const fetchInvoice = async () => {
            try {
                setLoading(true);
                // Fetch Invoice Data
                const invoiceResponse = await axiosInstance.get(`invoice/package/${invNum}`, {signal: controller.signal});
                if (!invoiceResponse.data || _.isEmpty(invoiceResponse.data)) {
                    throw new Error("No invoice found with the given number.");
                }
                const validContent = invoiceResponse.data.content.map((item) => ({
                    ...item,
                    id: uuidv4(),
                    itemId: item.itemId,
                    itemName: item.itemName,
                    quantity: sI(item.quantity) || 0,
                    price: sF(item.price) || 0,
                    total: sF(item.total) || 0,
                    lastPrice: sF(item.lastPrice) || 0,
                    stock: sF(item.stock) || 0,
                    comment: item.comment,
                }));
                // Fetch Customer Data
                const customerResponse = await axiosInstance.get(`customer/id/${invoiceResponse.data.header.customerId}`, {signal: controller.signal}
                );
                if (_.isEmpty(customerResponse.data)) {
                    throw new Error("Customer not found.");
                }
                // Set States
                setCustomer({
                    name: customerResponse.data.name,
                    id: customerResponse.data.id,
                    initialBalance: sF(customerResponse.data.initialBalance),
                    customerGroup: customerResponse.data.customerGroup,
                });
                setContentList(validContent);
                setSerialList(invoiceResponse.data.serial || []);
                setTotal(sF(invoiceResponse.data.header.total));
                setVat(sF(invoiceResponse.data.header.vat));
                // Handle Date Validation
                const invoiceDate = dayjs(invoiceResponse.data.header.date, "YYYY-MM-DD", true);
                if (invoiceDate.isValid()) {
                    setIDate(invoiceDate.toDate());
                } else {
                    notify("Invalid date format received from backend.", "error");
                    setIDate(new Date());
                    ;
                }
                setStatus(invoiceResponse.data.header.status);
                setPosted(invoiceResponse.data.header.posted);
                setAllStatus(invoiceResponse.data.header.status);
                // Set Statuses and Flags
                setLocation({
                    id: invoiceResponse.data.header.location.id,
                    name: invoiceResponse.data.header.location.name,
                });
                setDues(["Balance: None", "40: None", "60 None"]);
                setInvNumber(invNum);

            } catch (error) {
                notify(error.message, "error");
            } finally {
                setNewLoaded(true)
                setLoading(false);
            }
        };

        fetchInvoice();

        return () => {
            controller.abort(); // Cleanup
        };
    }

    const saveStatus = (stat) => {
        try {
            // 1. Add a check to ensure status exists before checking length
            if (stat && stat.length > 0) {

                setStatus(stat);
                performSave(stat); // Pass the fresh 'stat' directly!

                // 2. Move setAct inside if it depends on a successful status change

            } else {
                console.warn("Attempted to save an empty or invalid status.");
            }
        } catch (error) {
            // 3. Basic error handling
            console.error("Failed to update status:", error);
            // You might want to trigger a toast notification here
        }
    };
    const SerialList = () => {
        if (invNumber <= 0) return null;
        return (
            <Modal show={show} onHide={() => {
                setShow(false)
            }}>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Serial invoiceId={invNumber} setSerialList={setSerialList}
                            date={iDate ? iDate.toLocaleDateString() : ""}
                            mode={"SALE"} serialList={serialList} setShow={setShow} setAct={setAct}
                            customerName={customer ? customer.name : "No Customer"}/>
                </Modal.Body>

            </Modal>
        )
    }
    const handleImage = () => {
        setShowImage(true)
    }
    const TopMenu = () => {
        return (
            <>
                <MunshiMenu handle={handle}/>
            </>
        )
    }

    const SidebarContent = () => {
        return (
            <div className="flex flex-nowrap flex-shrink-1 justify-content-start align-content-start">
                <div className="card flex justify-content-center">
                    <Sidebar visible={visible} onHide={() => setVisible(false)}>
                        <InvoiceScroll invoices={invNumber} setInv={(invSelect) => getInvoice(invSelect)}
                                       setVisible={setVisible} invoiceList={invoiceList}/>
                    </Sidebar>
                </div>
            </div>
        )
    }
    const HeaderForm = () => {
        return (
            <div className="flex flex-column w-8  md:w-3 h-auto m-5 test-white rounded p-2"
                 style={{backgroundColor: "#526D82"}}>

                {!_.isEmpty(customer) && customerList &&
                    <FloatLabel>
                        <CustomerSelect customer={customer} setCustomer={setCustomer} id={"cid"}
                                        disable={isPosted || isApproved} loading={loading}
                                        customerList={customerList}/>
                        <label htmlFor="cid" className="text-white"
                               style={{backgroundColor: "#526D82"}}>Customer</label>
                    </FloatLabel>}

                {iDate &&
                    <FloatLabel className="pb-1 mt-1 w-full">
                        <Calendar selectionMode={"single"} value={(iDate)} onChange={(e) => setIDate(e.value)} id={"dt"}
                                  dateFormat="dd/mm/yy" className={"h-2rem mt-1"} showIcon
                                  disabled={isPosted || isApproved}/>
                        <label className="text-white pb-1" style={{backgroundColor: "#526D82"}}
                               htmlFor="date">Date</label>
                    </FloatLabel>}
                {location &&
                    <FloatLabel>
                        <LocationSelect setLocation={setLocation} id={"loc"} locationList={locationList}
                                        location={location} disable={isPosted || isApproved}
                                        setLoading={setLoading}/>
                        <label htmlFor="loc" className="text-white"
                               style={{backgroundColor: "#526D82"}}>Location</label>
                    </FloatLabel>}

            </div>

        )
    }
    const DrdTables = () => {
        if (transfer) return null
        return (
            <div className="flex-column flex-grow-1 w-5 md:w-2 h-auto text-base ml-3  mr-3">
                {customer.id > 0 && <DrdTable dues={dues}/>}
            </div>
        )
    }
    const Check = () => {
        if (transfer) return null
        if (contentList[0]?.itemId === 0 || !contentList[0]) return null
        return (
            <div className="h-auto w-8 hidden md:flex flex-nowrap align-self-center">
                {customer.id > 0 && status && !transfer &&
                    <InvoiceChecks status={status} setStatus={(stat) => saveStatus(stat)} disable={isPosted}
                                   level={level}
                                   user={user} isPosted={isPosted}/>}
            </div>

        )
    }

    const ToolBar = () => {
        return (
            <>
                <div className="flex flex-nowrap flex-shrink-1 justify-content-start h-auto">
                    <div className="align-content-center">
                        <Button icon="pi pi-arrow-right" onClick={() => setVisible(true)}/>
                    </div>
                    <div className="flex flex-nowrap   ">
                        <InvoiceTools setAction={(action) => setAct(action)} isPosted={isPosted} isApproved={isApproved}
                                      isDelivered={isDelivered} invNumber={invNumber} customerId={customer.id}
                                      xFer={transfer}/>
                    </div>
                    <div className="align-content-center h-auto">
                        <Button type="button" icon="pi pi-list" onClick={() => {
                            setShow(customer && customer.id > 0)
                        }}/>
                    </div>
                    <SerialList/>
                    <div className="align-content-center h-auto ml-1">
                        <Button type="button" icon="pi pi-image" disabled={invNumber === 0} onClick={handleImage}/>
                    </div>
                </div>
            </>
        )
    }
    if (showPrint && header && body) {
        return (
            <>
                <PrintInvoice header={header} body={body} setPrint={setShowPrint} setLoading={setLoading} vat={vat}
                              name={companyName}/>
            </>
        )
    } else if (!loading) {
        return (
            <>
                    <div style={{backgroundColor: "#27374D", height: "100vh"}} >
                    <ToastContainer autoClose={1000} position="top-right"/>
                    {showImage ? <Scanner loading={loading} setLoading={setLoading} invoice={invNumber} mode={"SALE"}
                                          showImage={showImage} setShowImage={setShowImage}/> : null}

                    <TopMenu/>
                    <div className="flex justify-content-between mt-1  ml-1 ">
                        <ToolBar/>
                        <div
                            className="flex flex-nowrap flex-shrink-1 justify-content-end align-content-center text-white">
                            <h1 className="font-bold text-center md:text-left align-self-center mr-4 text-base md:text-4xl  ">{transfer ? "Xfr" : "Invoice"}
                                : {invNumber === 0 ? "New" : invNumber}</h1>
                        </div>
                    </div>
                    <SidebarContent/>
                    <div className="flex w-full flex-row h-auto justify-content-around align-items-center mt-1">
                        <HeaderForm/>
                        <DrdTables/>
                        <Check/>
                    </div>
                    <div className="flex w-full h-auto justify-content-center">
                        {!loading &&
                            <InvoiceBody list={contentList} setList={setContentList}
                                         customerId={customer ? customer.id : 0}
                                         isPosted={isPosted}
                                         enablePriceEdit={isEnablePrice}
                                         isApproved={isApproved} invoiceId={invNumber}
                                         setLoading={setLoading} loading={loading}
                                         itemList={itemList} vat={vat}
                            />}
                    </div>
                    </div>

            </>
        );
    }
}


export default Invoice;
